/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_All_LevelsInputs */

const en_val_all_levels = /** @type {(inputs: Val_All_LevelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Levels`)
};

const es_val_all_levels = /** @type {(inputs: Val_All_LevelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los niveles`)
};

const fr_val_all_levels = /** @type {(inputs: Val_All_LevelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous niveaux`)
};

const de_val_all_levels = /** @type {(inputs: Val_All_LevelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Level`)
};

const ja_val_all_levels = /** @type {(inputs: Val_All_LevelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全レベル対応`)
};

const zh_val_all_levels = /** @type {(inputs: Val_All_LevelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有级别`)
};

const ar_val_all_levels = /** @type {(inputs: Val_All_LevelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع المستويات`)
};

const id_val_all_levels = /** @type {(inputs: Val_All_LevelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua Tingkat`)
};

const it_val_all_levels = /** @type {(inputs: Val_All_LevelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i Livelli`)
};

const ru_val_all_levels = /** @type {(inputs: Val_All_LevelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для всех уровней`)
};

const pt_val_all_levels = /** @type {(inputs: Val_All_LevelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os Níveis`)
};

const ko_val_all_levels = /** @type {(inputs: Val_All_LevelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 레벨`)
};

/**
* | output |
* | --- |
* | "All Levels" |
*
* @param {Val_All_LevelsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_all_levels = /** @type {((inputs?: Val_All_LevelsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_All_LevelsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_all_levels(inputs)
	if (locale === "es") return es_val_all_levels(inputs)
	if (locale === "fr") return fr_val_all_levels(inputs)
	if (locale === "de") return de_val_all_levels(inputs)
	if (locale === "ja") return ja_val_all_levels(inputs)
	if (locale === "zh") return zh_val_all_levels(inputs)
	if (locale === "ar") return ar_val_all_levels(inputs)
	if (locale === "id") return id_val_all_levels(inputs)
	if (locale === "it") return it_val_all_levels(inputs)
	if (locale === "ru") return ru_val_all_levels(inputs)
	if (locale === "pt") return pt_val_all_levels(inputs)
	return ko_val_all_levels(inputs)
});